<template>
    <div class="arche-loading">
      <div class="loadEffect">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div>
        {{$t('home.loading')}}
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    methods:{
    },
  };
</script>

<style lang="scss" scoped>
    .arche-loading {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loadEffect {
        position: relative;
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }

    .loadEffect span {
        position: absolute;
        display: inline-block;
        width: 3.2px;
        height: 3.2px;
        background: white;
        border-radius: 50%;
        -webkit-animation: load 1.04s ease infinite;
    }

    @-webkit-keyframes load {
        0% {
        opacity: 1;
        }

        100% {
        opacity: .2;
        }
    }

    .loadEffect span:nth-child(1) {
        top: 50%;
        left: 0;
        margin-top: -1.6px;
        -webkit-animation-delay: .13s;
    }

    .loadEffect span:nth-child(2) {
        top: 2.8px;
        left: 2.8px;
        -webkit-animation-delay: .26s;
    }

    .loadEffect span:nth-child(3) {
        top: 0;
        left: 50%;
        margin-left: -1.6px;
        -webkit-animation-delay: .39s;
    }

    .loadEffect span:nth-child(4) {
        top: 2.8px;
        right: 2.8px;
        -webkit-animation-delay: .52s;
    }

    .loadEffect span:nth-child(5) {
        top: 50%;
        right: 0;
        margin-top: -1.6px;
        -webkit-animation-delay: .65s;
    }

    .loadEffect span:nth-child(6) {
        right: 2.8px;
        bottom: 2.8px;
        -webkit-animation-delay: .78s;
    }

    .loadEffect span:nth-child(7) {
        bottom: 0;
        left: 50%;
        margin-left: -1.6px;
        -webkit-animation-delay: .91s;
    }

    .loadEffect span:nth-child(8) {
        bottom: 2.8px;
        left: 2.8px;
        -webkit-animation-delay: 1.04s;
    }
</style>